import { RoleEdit } from "./RoleEdit";
import { RolesList } from "./RolesList";
import BeenHereOutlined from "@material-ui/icons/BeenhereOutlined";
import { RoleCreate } from "./RoleCreate";
import {
  ActionPermissionDefinitionGroup,
  ActionPermissionDefinitionPermission,
} from "../../../common/data/service-proxies";

export default {
  icon: BeenHereOutlined,
  list: RolesList,
  create: RoleCreate,
  edit: RoleEdit,
};

export type GroupPermissions = {
  group: ActionPermissionDefinitionGroup;
  permissionGroups:
    | {
        permissionGroup: string | null | undefined;
        permissionGroupDisplayName: string | null | undefined;
        permissions: ActionPermissionDefinitionPermission[];
      }[]
    | null
    | undefined;
};
